module.exports = __webpack_public_path__ + "img/ibmp-nasal-negative-without-symptons.491a82e5.png";